import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

export type Language = 'en' | 'ar';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLanguage = i18n.language as Language;
  const isRTL = currentLanguage === 'ar';

  // Update document direction when language changes
  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage, isRTL]);

  const changeLanguage = (lang: Language) => {
    // Change the language without modifying the URL
    // The URL structure (with or without language prefix) is preserved
    i18n.changeLanguage(lang);

    // Store language preference explicitly in localStorage for persistence
    localStorage.setItem('i18nextLng', lang);

    // Refresh the page to reload all content in the new language
    // This ensures API responses and all content are fetched in the selected language
    window.location.reload();
  };

  return {
    language: currentLanguage,
    isRTL,
    changeLanguage,
    t: i18n.t,
  };
};
